<template>
    <svg :style="svgStyle">
        <text
            x="50%"
            y="50%"
            text-anchor="middle"
            dominant-baseline="central"
            :style="textStyle"
        >
            {{ avatarLetter }}
        </text>
        <title>{{ name }}</title>
    </svg>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: "40",
        },
    },
    computed: {
        avatarLetter() {
            let letter = this.name[0].toUpperCase();
            const parts = this.name.split(" ");

            // If there's more than one name, get the last name and add that too.
            if (parts.length > 1) {
                letter = letter + parts[parts.length - 1][0].toUpperCase();
            }

            return letter;
        },
        svgStyle() {
            // use hsl to define the background color.
            const letterIndex
                = this.avatarLetter.charCodeAt() - this.avatarLetter[1].charCodeAt() - 128;
            const hue = (360 / 26) * letterIndex;
            const backgroundColor = `hsl(${hue}, 68%, 48%)`;
            return {
                background: backgroundColor,
                borderRadius: this.rounded ? "100%" : "0",
                height: `${this.size}px`,
                width: `${this.size}px`,
            };
        },
        textStyle() {
            return {
                fill: "rgba(255, 255, 255, .7)",
                fontFamily: "'Lucida Console', Monaco, monospace",
                fontSize: `${this.size * 0.6}px`,
            };
        },
    },
};
</script>
